///<reference path="require.d.ts"/>

import IHttpInterceptor = angular.IHttpInterceptor;
const hp = angular.module("hp", []);

hp.factory('$exceptionHandler', () => {
    return (exception: Error) => {
        Raven.captureException(exception);
        throw exception;
    };
});
// MHP-70 IE9 xdomain 用に _origin パラメータを追加
if (/MSIE 9/.test(navigator.userAgent)) {
    hp.factory("originInterceptor", (): IHttpInterceptor => {
        return {
            request: (config: angular.IRequestConfig): angular.IRequestConfig => {
                const hasQuery = config.url.indexOf('?') >= 0;
                const sep = hasQuery ? '&' : '?';
                const origin = encodeURI(location.protocol + '//' + location.hostname);
                config.url = `${config.url}${sep}_origin=${origin}`;
                return config;
            }
        };
    });
    hp.config(['$httpProvider', ($hp: angular.IHttpProvider) => {
        $hp.interceptors.push("originInterceptor");
    }]);
}
hp.run(["$http", ($http: angular.IHttpService) => {
    const match = /\/preview\/(\d+)$/.exec(location.pathname);
    if (!match) return;
    $http.defaults.headers.common['X-Preview-ID'] = match[1];
}]);

import "./services/CheckedRoomRepository";
import "./controllers/MapController";
import "./controllers/RoomsController";
import "./controllers/NewsController";
import "./controllers/InquiryController";
import "./controllers/CitiesController";
import "./controllers/RailwaysController";
import "./controllers/RoomsPageController";
import "./controllers/CriteriaController";
import "./controllers/RoomDetailCheckController";
import "./controllers/InquiryButtonController";
import "./controllers/RoomInquiryController";



// WEBPACK FOOTER //
// ./bootstrap.ts